import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createOutro(_, outro) {
    const response = await axios.post('/blade/outros', outro);
    return response.data.outro;
  },
  async getOutros() {
    const response = await axios.get('/blade/outros');
    return response.data.outros;
  },
  async getOutro(_, { outroId }) {
    const { data } = await axios.get(`/blade/outros/${outroId}`);
    return data;
  },
  async getOutroTypes({ dispatch }) {
    return dispatch('getOutro', { outroId: 'types' });
  },
  async updateOutro(_, outro) {
    const response = await axios.patch(`/blade/outros/${outro._id}`, outro);
    return response.data.outro;
  },
  async deleteOutro(_, { outroId, _id }) {
    const did = outroId || _id;
    const response = await axios.delete(`/blade/outros/${did}`);
    return response.data.outro;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/outros.js